/* eslint-disable react/jsx-props-no-spreading */
import { EditComponentProps } from "material-table";
import {
  makeStyles,
  Theme,
  createStyles,
  TextField,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import React from "react";
import { Field } from "formik";
import { ConnectionConfigDataRow } from "../../../../types/config";
import { PlainSelect, PlainSelectDef } from "../../../../components";
import { OptionData } from "../../../../types";
import { ConnectionDevicesApi } from "../../../../helpers/api/connection-devices-api";
import { ConnectionDeviceNullValue } from "../helpers/connection-config-helper";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: "12rem",
      width: "90%",
    },
  })
);

interface Props extends EditComponentProps<ConnectionConfigDataRow> {
  autoFocus?: boolean;
  onError?: (error: any) => void;
}

/** パス/端末機種編集コンポーネント */
export function PathAndConnectionDeviceEditComponent(props: Props) {
  const classes = useStyles();

  const { value: fieldValue, onChange, onError } = props;

  // 端末機種 選択値
  const calculatedValue =
    Object.keys(fieldValue.connectionDevice).length === 0
      ? ConnectionDeviceNullValue
      : fieldValue.connectionDevice;

  // 端末機種 選択肢
  const [connectionDeviceOptions, setConnectionDeviceOptions] = React.useState<
    OptionData[]
  >([]);

  // 端末機種 選択肢初期化
  const initConnectionDeviceOptions = () => {
    const fetchData = async () => {
      try {
        const res: any = await ConnectionDevicesApi.list();
        const optionData = res.data.map((row: any) => ({
          name: row.name,
          value: String(row.id),
        }));
        // リストの先頭に未選択用の値を追加
        optionData.unshift(ConnectionDeviceNullValue);
        setConnectionDeviceOptions(optionData);
      } catch (error: any) {
        if (onError) {
          onError(error);
        }
      }
    };
    fetchData();
  };

  // 初回のみ
  React.useEffect(() => {
    // 端末機種 選択肢初期化
    initConnectionDeviceOptions();
  }, []);

  //--------------------
  // コンポーネント
  return (
    // eslint-disable-next-line react/destructuring-assignment
    <Field name={props.columnDef.field}>
      {(args: any) => {
        const { field, form } = args;
        const { name } = field;
        const { touched, errors, setFieldValue } = form;

        // onChange, onBlur, name and value は
        // name で引き当てて HtmlのReactコンポーネントに自動注入するが、
        // このコンポーネントは２つフィールドを含む都合上設定が行われない。
        // フォーカスアウト時にはtouchedにできないが、
        // 適用ボタンを押下時にtouchedになるのでそれで良しとする。

        // フィールドエラー表示判定: パス
        const showErrorPath = () => {
          let isError = false;
          if (touched.pathAndConnectionDevice) {
            isError = touched.pathAndConnectionDevice.path && errors.path;
          }
          return isError;
        };
        // フィールドエラー表示判定: 端末機種
        const showErrorConnectionDevice = () => {
          let isError = false;
          if (touched.pathAndConnectionDevice) {
            isError =
              touched.pathAndConnectionDevice.connectionDevice &&
              errors.connectionDevice;
          }
          return isError;
        };

        return (
          <>
            <div>
              {/*
                パス

              */}
              <FormControl
                className={classes.formControl}
                error={"path" in errors}
              >
                <TextField
                  size="small"
                  placeholder="パス"
                  inputProps={{
                    style: { fontSize: 13 },
                  }}
                  value={fieldValue.path}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newData = {
                      ...fieldValue,
                      path: event.target.value,
                    };
                    onChange(newData); // for MaterialTable
                    setFieldValue(name, newData); // for Formik
                  }}
                  error={showErrorPath()}
                />
                {showErrorPath() ? (
                  <FormHelperText>{errors.path}</FormHelperText>
                ) : null}
              </FormControl>
            </div>

            {/*
              端末機種

            */}
            <div>
              <FormControl
                className={classes.formControl}
                error={"connectionDevice" in errors}
              >
                <PlainSelect
                  {...props}
                  {...field}
                  id="id_connectionDevice"
                  label=""
                  data={calculatedValue.value}
                  defs={connectionDeviceOptions}
                  handleChange={(event: React.ChangeEvent<any>) => {
                    const { value: eValue } = event.target;
                    if (typeof eValue === "string") {
                      const selectedConnectionDevice = connectionDeviceOptions.find(
                        (def: PlainSelectDef) => def.value === eValue
                      );
                      if (selectedConnectionDevice) {
                        const newData = {
                          ...fieldValue,
                          connectionDevice: {
                            name: selectedConnectionDevice.name,
                            value: eValue,
                          },
                        };
                        props.onChange(newData); // for MaterialTable
                        setFieldValue(name, newData); // for Formik
                      }
                    }
                  }}
                  error={touched[name] && errors[name]}
                  helperText={touched[name] && errors[name]}
                  autoFocus={false}
                />
                {showErrorConnectionDevice() ? (
                  <FormHelperText>{errors.connectionDevice}</FormHelperText>
                ) : null}
              </FormControl>
            </div>
          </>
        );
      }}
    </Field>
  );
}
